<script setup>
import {onMounted, onBeforeUnmount, computed} from 'vue'
import GridScheduleItem from './GridScheduleItem.vue';
import WSMeta from './WSMeta.vue';

onMounted( () => {
    // console.log( 'dispatch grid mounted event' )
    const gridMounted = new CustomEvent( 'gridMounted', { 'detail': { 'state': '' } } )
    document.dispatchEvent( gridMounted )
})

onBeforeUnmount( () => {
    // console.log( 'dispatch grid before unmounted event' )
    const gridUnMounted = new CustomEvent( 'gridUnMounted', { 'detail': { 'state': '' } } )
    document.dispatchEvent( gridUnMounted )
})

const props = defineProps({
        items: Array,
        dateTimes: Object,
        locations: Array
})
const sessionsByDay = (dayAsSlug) => {
    // console.log(dayAsSlug)
    return props.items.filter((item) => {
        return item.dayAsSlug === dayAsSlug
    })
}
const locations = computed(() => {
    return props.locations.filter((loc) => {
        return loc.loc_show_as_column === true
    })
})

const gridStyles = ( timings, locations ) => {
    let timeRows = '';
    timings.forEach( (timing) => {
        timeRows += '[time-' + timing.hour + '] var(--col-height) '
    })

    let locationColumns = '';
    locations.forEach( (location) => {
        locationColumns += '[' + location.slug + '] var(--col-width) '
    })

    const gridCSS = `
        display: grid;
        grid-template-rows: auto auto ${ timeRows };
        grid-template-columns: var(--col-width-times) ${ locationColumns } var(--col-width-end);

        width: calc( ( var(--col-width) * ${ locations.length } ) + var(--col-width-times) + var(--col-width-end) + ( var( --sle-grid-col-gap ) * ${ locations.length } + 1; ?> ) );`

    return gridCSS
}
</script>

<template>
    <template v-for="(day, index) in props.dateTimes" :key="index" >
        <h3 class="sles__day__title">{{ day.dayInText }}</h3>
        <div
            class="sles__day" 
            :id="day.dayAsSlug" 
            :data-date="day.dayAsSlug"
            :style="gridStyles( day.timings, locations )"
        >
            <div class="meta-schedule-item meta-schedule-item--timing sles--no-time-marker" style="grid-row: 1 / span 1; grid-column: 1 / span 1;"></div>
            <div class="meta-schedule-item meta-schedule-item--timing sles--no-time-marker" style="grid-row: 2 / span 1; grid-column: 1 / span 1;"></div>
            <div v-for="(time, index) in day.timings"
                :key="index"
                class="meta-schedule-item meta-schedule-item--timing" 
                :style="`grid-row: ${ index + 3 } / span 1; grid-column: 1 / span 1`"
            >{{ time.label }}
                <span class="meta-schedule-item--timing__30">{{ time.hour }}:30</span>
            </div>
            
            <div class="meta-schedule-item meta-schedule-item--location meta-schedule-item--location--first" style="grid-column: 1 / span 1"></div>
            <div v-for="(location, index) in locations" 
                :key="index"
                class="meta-schedule-item meta-schedule-item--location" 
                :style="'grid-column: ' + (index + 2) + ' / span 1'"
            >
                <span v-if="location.loc_roomnumber && location.loc_roomnumber !== ''" class="meta-schedule-item--location__roomnumber">{{ location.loc_roomnumber }}</span>
                <span class="meta-schedule-item--location__name">{{ location.title }}</span>
            </div>
            <GridScheduleItem v-for="(item, index) in sessionsByDay(day.dayAsSlug)" :key="index" :item="item"/>
            <WSMeta :day="day" />
        </div>
    </template>
</template>